import React, { Component } from 'react';

class SingIn extends Component {
    render() {
        return (
            <div>
                <h1>Sign In</h1>
            </div>
        );
    }
}

export default SingIn;
